import { Button } from '@connected/ui/components/button';
import { Trash2 } from 'lucide-react';

import type { TechnicalDrawing } from '../utils/drawing-types';

import { useDeleteDrawing } from '../hooks/use-drawing-mutations';

export type DrawingDeleteButtonProps = {
    technicalDrawing: TechnicalDrawing;
    electricalProjectVersionId: string;
};

export function DrawingDeleteButton({ technicalDrawing, electricalProjectVersionId }: DrawingDeleteButtonProps) {
    const { mutation: deleteDrawingMutation, disabled } = useDeleteDrawing({ electricalProjectVersionId });

    return (
        <Button
            className="bg-background/80 hover:bg-background"
            variant="ghost"
            size="icon"
            onClick={() => {
                deleteDrawingMutation.mutate({
                    params: {
                        query: {
                            ElectricalProjectTechnicalDrawingId: technicalDrawing.ElectricalProjectTechnicalDrawingId,
                        },
                    },
                });
            }}
            disabled={disabled}
        >
            <Trash2 />
        </Button>
    );
}
